import { connect } from 'react-redux';
import View from './WhatIfsSectionView';
import { selectedSection as whatIfsSelectedSection } from '../WhatIfsSelector';
import {
  setSelectedSection,
  setCurrentViewId,
} from '../WhatIfsActions';
import { goalId as selectedGoalId, goalType as selectedGoalType } from '../../FinancialPlanGoalDropdown/FinancialPlanGoalDropdownSelector';

const mapStateToProps = (state, ownProps) => ({
  goalId: selectedGoalId(state, ownProps),
  goalType: selectedGoalType(state, ownProps),
  focused: whatIfsSelectedSection(state, ownProps) === ownProps.sectionId,
});

const mapDispatchToProps = dispatch => ({
  setSelectedSection: (clientId, goalId, selectedSection) => (event) => {
    event.stopPropagation();
    dispatch(setSelectedSection(clientId, goalId, selectedSection));
  },
  setCurrentViewId: (clientId, goalId) => ({ id }) => (event) => {
    event.stopPropagation();
    dispatch(setCurrentViewId(clientId, goalId, id));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(View);
